import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';



export const AuditTableLoadMore = ({ continuationToken}) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("continuationToken", continuationToken);
    return (
        <div className="card p-2">
            <div className="row g-1 gx-md-2 align-items-center">
                <div className="col-auto col-md-12">
                    <div className="h5 ls-1 my-auto o-70 text-center">
                        <Link type="button" to={`/funecap/audit?${searchParams}`}>
                        + Charger plus d'entrées
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};